// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1BDyd","emails":"CreateEditClinics_emails__33PCR","emailTagLabel":"CreateEditClinics_emailTagLabel__2T6jA"};